import { defineNuxtRouteMiddleware, navigateTo } from 'nuxt/app'
import { useThingsboard } from '~/composables/useThingsboard'

export default defineNuxtRouteMiddleware(() => {
  if (typeof window === 'undefined') return
  const tb = useThingsboard()
  if (!tb.isAuthenticated()) {
    return navigateTo('/login')
  }
})